import React from 'react';
import { Referral } from '../../domain/types';
import { SiblingReferralLink } from './SiblingReferralLink';

type Props = {
    referral: Referral;
}

export function SiblingDetails({ referral }: Props) {
    const siblings = referral.clientSiblingReferrals || [];
    return (
        <div className="flex pb-2">
            <div className="w-1/2">
                Sibling
            </div>
            <div className="w-1/2 flex flex-wrap">
                {
                    siblings.map((s) => (
                        <SiblingReferralLink size={ 400 } className="mr-2 pb-2" key={ s.guid } siblingReferral={ s }/>
                    ))
                }
            </div>
        </div>
    );
}